<ion-content class="ion-padding">
  <ul class="font-10 line-100 ion-no-padding" *ngIf="type === 'account_voucher'">
    <li><p>{{ 'NEWS_CARD.account_voucher.tnc.point1' | translate: { lastDate: lastDate, month: month, year: year } }}</p></li>
    <li><p>{{ 'NEWS_CARD.account_voucher.tnc.point2' | translate: { plan: 'PRODUCT.account.wedding_account_full.short' | translate } }}</p></li>
    <li><p>{{ 'NEWS_CARD.account_voucher.tnc.point3' | translate }}</p></li>
  </ul>
</ion-content>